<template>
<div>
  <div class="main">
    <div class="main-slider media-lg-768">
      <ul>
        <li class="first"></li>
        <li :class="i === 0 ? 'current':''" :data-src="item.coverImage" v-for="(item, i) in coverlistData" :key="item.indexTitle">
          <a :href="item.href">
            <span :class="i === 0 ? 'current-title':''"> {{ item.title }}</span>
            <span :class="i === 0 ? 'hide':''">: </span>
            <span :class="i === 0 ? 'current-content':''">{{ item.subTitle }}</span></a>
        </li>
        <li class="last"></li>
      </ul>
    </div>
    <Nav/>
  </div>

  <div id="content">
   <div class="media-lg-768-block" style="height:66px;"></div>
   <a-row type="flex" justify="center" align="top">
      <a-col :span="15">
        <ContentLeft/>
      </a-col>
      <a-col :span="1" class="media-lg-768"></a-col>
      <a-col :span="6" class="media-lg-768">
        <content-right/>
      </a-col>
    </a-row>
  </div>
  <div id="footer">
    <Footer/>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import Nav from './Nav.vue';
import ContentLeft from './ContentLeft.vue';
import ContentRight from './ContentRight.vue';
import Footer from './Footer.vue';

const coverlistData = [];
const imgs = [];
var imageShow;
export default {
  metaInfo() {
    return {
      title: 'Bennu\'s Blog - 个人博客',
      meta: [{
        name: 'keywords',
        content: 'bennu, blog, software development, development, 个人博客, 技术分享'
      }, {
        name: 'description',
        content: 'Personal blog including software development, essay, mood, etc.'
      }]
    };
  },
  name: 'Index',
  components: {
    Nav,
    ContentLeft,
    ContentRight,
    Footer
  },
  data() {
    return {
      coverlistData,
      imgs
    };
  },
  mounted() {
    coverlistData.splice(0, coverlistData.length);
    imgs.splice(0, imgs.length);
    if (imageShow !== undefined) {
      imageShow.stop();
      imageShow = null;
    }
    imageShow = new ImgShow();
    axios
      .get(this.GLOBAL.host + '/passage/cover')
      .then(response => {
        var res = response.data;
        if (res.code === 1000) {
          for (var index in res.data) {
            var passage = res.data[index];
            var titleArray = passage.coverTitle.split(':');
            if (titleArray.length !== 2) {
              titleArray = [passage.coverTitle, ''];
            }
            coverlistData.push({
              href: `/p/${passage.indexTitle}`,
              title: titleArray[0],
              subTitle: titleArray[1],
              coverImage: passage.coverImage
            });
            // preload
            new Image().src = passage.coverImage;
            if (index === 0) {
              imageShow.setBackground(passage.coverImage);
            }
            imgs.push(passage.coverImage);
          }
          this.$nextTick(function() {
            imageShow.start();
          });
        } else {
          this.$notification.error({
            message: '查询失败',
            description: res.message
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};

// index slider begin
function ImgShow() {}

ImgShow.prototype = {
  index: -1, // Array Subscript Initial -1
  elements: null, // DOM Element
  stopFlag: false, // Stop Autoplay
  destroy: false,
  /**
   *  Program Entry
   */
  start: function () {
    this.initParas();
    this.autoPlay();
    this.initEvent();
  },
  stop: function() {
    this.destroy = true;
  },
  /**
   *  Initial Parameters
   */
  initParas: function () {
    // init imgs
    if (imgs.length < 8) {
      // adjust style according to the image array's length
      var newDist = (8 - imgs.length) * parseInt($('.main-slider ul li').css('height')) / 2 + parseInt($('.main-slider ul').css('top'));
      $('.main-slider ul').css('top', newDist + 'px');
    }
    this.setBackground(imgs[0]);
    this.stopFlag = false;
  },
  /**
   * register events
   */
  initEvent: function () {
    this.mouseover();
    this.mouseclick();
  },
  /**
   * Transfer to Next Item
   * @param index
   */
  itemMove: function (index) {
    // Adjust style
    var items = $('.main-slider ul li');
    items.each(function () {
      var a = this.childNodes[0];
      if (this.className === 'current') {
        this.className = '';
        a.childNodes[0].className = '';
        a.childNodes[1].className = '';
        a.childNodes[2].className = '';
      }
    });
    var current = items[index + 1];
    if (current == null) {
      return;
    }
    current.className = 'current';
    current.childNodes[0].childNodes[0].className = 'current-title';
    current.childNodes[0].childNodes[1].className = 'hide';
    current.childNodes[0].childNodes[2].className = 'current-content';
  },
  /**
   * Mouseover event
   */
  mouseover: function () {
    var items = $('.main-slider ul li');
    var self = this;
    items.on('mouseover', function () {
      if (this.className === 'first' || this.className === 'last') {
        return;
      }
      self.stopFlag = true;
      items.each(function () {
        var a = this.childNodes[0];
        if (this.className === 'current') {
          this.className = '';
          a.childNodes[0].className = '';
          a.childNodes[1].className = '';
          a.childNodes[2].className = '';
        }
      });
      // Adjust style
      var current = this.childNodes[0];
      this.className = 'current';
      current.childNodes[0].className = 'current-title';
      current.childNodes[1].className = 'hide';
      current.childNodes[2].className = 'current-content';
      self.setBackground(imgs[$(this).index() - 1]);
      self.index = $(this).index() - 1;
    });
    items.on('mouseout', function () {
      self.stopFlag = false;
    });
  },
  /**
   * Mouseclick Event
   */
  mouseclick: function () {
  },
  /**
   * Autoplay
   */
  autoPlay: function () {
    var self = this;
    setInterval(function () {
      if (self.stopFlag || self.destroy) {
        return;
      }
      self.index++;
      var current = self.index % imgs.length;
      self.setBackground(imgs[current]);
      self.itemMove(current);
    }, 4000);
  },
  /**
   * Set Background
   */
  setBackground: function (url) {
    $('.main-slider').css('background', 'url(' + url + ')').css('background-size', 'cover').css('background-repeat', 'no-repeat');
    $('.main-slider').css('filter', 'progid:DXImageTransform.Microsoft.AlphaImageLoader(' + 'src=' + url + ',sizingMethod="scale")'); // for IE
  }
};
// index slider begin
</script>

<style scoped>
* {
  font-size: 14px;
}

html,
ul,
li {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
}

body {
  font: 12px/1.5 PingFangSC-Regular, Tahoma, 'Microsoft Yahei', sans-serif;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: normal;
  font-stretch: normal;
  font-size: 12px;
  line-height: 1.5;
  font-family: PingFangSC-Regular, Tahoma, "Microsoft Yahei", sans-serif;
  color: #666;
  background: #fff;
}

@media (max-width: 768px) {
  .media-lg-768 {
    display: none;
  }
  .media-lg-768-block {
    display: block;
  }
}

@media (min-width: 769px) {
  .media-lg-768-block {
    display: none;
  }
}

.clear-decoration {
  color: #202020;
  text-decoration: none;
}

a:hover {
  color: #202020;
  text-decoration: none;
}

a:link {
  color: #202020;
  text-decoration: none;
}

a:visited {
  color: #202020;
  text-decoration: none;
}

a:active {
  color: #202020;
  text-decoration: none;
}

.main {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
}

.hide {
  display: none;
}

.widget .tag-cloud a {
  border: 1px solid #ebebeb;
  padding: 2px 7px;
  color: #959595;
  line-height: 1.5em;
  display: inline-block;
  margin: 0 7px 7px 0;
  -webkit-transition: all .2s ease;
  -o-transition: all .2s ease;
  transition: all .2s ease;
  font-size: 13px;
}

.widget .about a {
  display: block;
  border-bottom: 1px dashed #303030;
  padding-bottom: 5px;
  margin-bottom: 5px;
  color: #959595;
  -webkit-transition: all .2s ease;
  -o-transition: all .2s ease;
  transition: all .2s ease;
}

.widget .friend-links a:last-child {
  margin-bottom: 0;
}

.main-footer .widget .tag-cloud a {
  border: 1px solid #303030;
}

.copyright {
  background: #111;
  text-align: center;
  color: #555;
  padding-top: 14px;
  padding-bottom: 20px;
  border-top: 1px solid #303030;
}

.copyright .item {
  height: 20px;
}

.beian a {
  color: #555;
}

.testimg {
  width: 500px;
  height: 500px;
}

.main-slider {
  cursor: pointer;
  height: 488px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin-top: 0px;
  position: relative;
  overflow: hidden;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  -ms-filter: "progid:DXImageTransform.Microsoft.Shadow(Strength=4,Direction=135, Color='#000000')";
  filter: progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#000000');
  filter: progid:DXImageTransform.Microsoft.Shadow(color='#969696', Direction=125, Strength=5);
}

.main-mask {
  top: 0px;
  position: absolute;
  z-index: 5;
  height: 100px;
  width: 100%;
  background: rgba(255, 255, 255, 0);
  background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));
  background: -o-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));
  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));
  background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=rgba(255, 255, 255, 0), endColorstr=rgba(255, 255, 255, 0.6));
}

.main-slider ul {
  position: absolute;
  z-index: 3;
  right: 90px;
  top: 66px;
}

.main-slider .first {
  width: 245px;
  height: 33px;
  background: rgba(255, 255, 255, 0);
  background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: -o-linear-gradient(top, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: linear-gradient(to top, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=rgba(255, 255, 255, 0.8), endColorstr=rgba(255, 255, 255, 0));
}

.main-slider .last {
  width: 245px;
  height: 33px;
  background: rgba(255, 255, 255, 0);
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: -o-linear-gradient(bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: -moz-linear-gradient(bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=rgba(255, 255, 255, 0.8), endColorstr=rgba(255, 255, 255, 0));
}

.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.main-slider ul li {
  width: 245px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: left;
  padding-left: 15px;
  color: #000;
  font: 400 14px/37px 'Microsoft YaHei';
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.main-slider ul li:not(.first, .last) {
  background-color: #fefefe;
  cursor: pointer;
}

.main-slider ul:hover {
  cursor: pointer;
}

.main-slider .current {
  background-color: #fefefe;
  height: 76px;
  position: relative;
}

.main-slider .current-title {
  width: 245px;
  height: 30px;
  font: 24px PingFangSC-Regular, Tahoma, 'Microsoft Yahei', sans-serif;
  color: #41b8e4;
  text-align: left;
  position: absolute;
  top: 10px;
  left: 0;
  padding-left: 15px;
}

.main-slider .current-content {
  width: 245px;
  text-align: left;
  position: absolute;
  top: 35px;
  left: 0;
  padding-left: 15px;
  padding-right: 15px;
  color: #666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
